import Vue from 'vue';
//将时间戳转换成日期（2017-05-10 11：20：33）
Vue.filter("toTimeLocl",function(dateTimeStamp){
	return new Date(dateTimeStamp).toLocaleString();
});

Vue.filter("toTimeLoc2",function(dateTimeStamp){
	var   now = new Date(dateTimeStamp);
	var   year=now.getFullYear();     
	var   month=now.getMonth()+1;     
	var   date=now.getDate();     
	var   hour=now.getHours();     
	var   minute=now.getMinutes();     
	var   second=now.getSeconds();     
	if(month<10)
	{
		month = "0"+ month;
	}
	if(date<10)
	{
		date = "0"+ date;
	}
	if(hour<10)
	{
		hour = "0"+ hour;
	}
	if(minute<10)
	{
		minute = "0"+ minute;
	}
	if(second<10)
	{
		second = "0"+ second;
	}
	return   year+"-"+month+"-"+date+"   "+hour+":"+minute+":"+second; 
});
Vue.filter("toTimeLoc",function(dateTimeStamp){
	if(dateTimeStamp){
		var   now = new Date(dateTimeStamp);
		var   year=now.getFullYear();     
		var   month=now.getMonth()+1;     
		var   date=now.getDate();         
		return   year+"/"+month+"/"+date; 
	}else{
		return '';
	}
});
//价格保留两位小数
Vue.filter("price2",function(price){
	if(price&&common.isNumber(price))
	{
		return (Math.round(Number(price))/100).toFixed(2);
	}
	else
	{
		return "0.00";
	}
});
//空数据展示
Vue.filter("none",function(value){
	if(value == 0)
	{
		return "0";
	}
	if(!value)
	{
		return "--";
	}
	else
	{
		return value;
	}
});
//将时间戳转换成日期
Vue.filter("toRiqi",function(nS) {
	if(nS){
		var time = new Date(nS);
		var y = time.getFullYear();
		var m = time.getMonth()+1;
		var d = time.getDate();
		return y+"年"+m+"月"+d+"日";
	}else{
		return '';
	}
})
//字符串超过长度变成省略号显示
Vue.filter("stringLeng",function(value,leng) {
	if(value)
	{
		if(leng&&value.length>parseInt(leng))
		{
			return value.substring(0,parseInt(leng))+"...";
		}
		else
		{
			return value;
		}
	}
	else
	{
		return "";
	}
})
Vue.filter("dateFormat",function (value) {
	if (!value) return ''
	value = value.replace('T',' ')
	return value
})





// WEBPACK FOOTER //
// ./src/store/filter.js